<template>
    <router-view :websiteid="websiteid" :readonly="readonly"/>
</template>

<script>
    export default{
        name: "App",
        data: function(){
            return{
                userinfo: JSON.parse(localStorage.getItem('user')),
                readonly: true,
                websiteid: this.$route.params.websiteid // for standalone: window.myAppConfig.websiteid
            }
        },
        methods: {
        },
        mounted(){
            const userData = JSON.parse(localStorage.getItem('user'));
            if(userData && (userData.websiteid.includes(this.websiteid) || userData.isAdmin == true) ){
                this.readonly = false
            }
        }
    }
</script>